<template>
  <validation-observer
    ref="saveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="credentialProcessHistorySaveModal"
      body-class="position-static"
      centered
      :title="'Cập nhật yêu cầu'"
      no-close-on-backdrop
      @show="onShow"
      @hidden="onHide"
    >
      <b-form>
        <b-form-group>
          <template v-slot:label>
            Mô tả yêu cầu<span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors}"
            name="Mô tả yêu cầu"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="targetItem.name"
              placeholder="Mô tả yêu cầu"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          v-for="(item, index) in item.filesName"
          :key="index"
          ref="row"
        >
          <template v-slot:label>
            File yêu cầu {{ index + 1 }}
          </template>
          <b-form-file
            ref="inputFileRef"
            :placeholder="item"
            @change="event => uploadFile(event, index)"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('credentialProcessHistorySaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BForm, BFormFile,
  BFormGroup, BFormInput,
  BModal
} from 'bootstrap-vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import { mapActions, mapGetters } from 'vuex'
import { showSuccessToast, showErrorToast, showWarningToast } from '@/utils/notification'
import { getUser } from '@/auth/utils'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'CredentialProcessHistorySaveModal',
  directives: {
    Ripple,
  },
  components: {
    BModal,
    BButton,
    BFormGroup,
    BFormInput,
    BFormFile,
    BForm,
    Ripple,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    item: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      user: getUser(),
      targetItem: {
        name: '',
        filesId: [],
      },
    }
  },
  computed: {
    ...mapGetters({

    }),
  },
  methods: {
    ...mapActions({
      uploadSample: 'credentialProcessHistory/uploadSample',
      updateCredentialProcessRequest: 'credentialProcessHistory/updateCredentialProcessRequest',
    }),
    onShow() {
      if (this.item) {
        this.targetItem = { ...this.item }
      }
    },
    onHide() {
      this.targetItem = {
        name: '',
        filesId: [],
      }
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },

    async uploadFile(e, index) {
      this.isLoading = true
      const formData = new FormData()
      const { files } = e.target
      if (files.length === 0) {
        showWarningToast(this, 'File tài liệu đang bị trống')
        this.isLoading = false
        return
      }

      files.forEach(file => formData.append('files', file))

      this.mediaIds = await this.uploadSample(formData)

      if (this.mediaIds.length > 0 && this.targetItem.filesId.length === 0) {
        this.targetItem.filesId.push(this.mediaIds[0])
        showSuccessToast(this, 'Upload file thành công')
      } else if (this.mediaIds.length > 0 && this.targetItem.filesId.length > 0) {
        this.targetItem.filesId[index] = this.mediaIds[0]
        showSuccessToast(this, 'Upload file thành công')
      } else {
        showErrorToast(this, 'Có lỗi xẩy ra')
      }
      this.isLoading = false
    },
    async onSave(type = null) {
      const valid = this.$refs
        .saveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = await this.updateCredentialProcessRequest({
            id: this.item.id,
            params: this.targetItem,
          })
          if (response) {
            const {
              isSuccessful,
              message,
            } = response
            if (isSuccessful) {
              showSuccessToast(this, message)
              if (type === 'hide') {
                this.$bvModal.hide('credentialProcessHistorySaveModal')
              }
              this.$emit('succeed')
            } else {
              showErrorToast(this, message)
            }
          }
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
